import { Module } from 'vuex';
import { EmpathyXConfig, EmptySearchState, QueryOrigin } from '../../models';
import { getDiscoveryWallModule } from '../discovery-wall/discovery-wall.module';
import { getRecommendationsModule } from '../recommendations/recommendations.module';
import { RootStoreState } from '../store.interfaces';

export function getEmptySearchModule(initialConfig: EmpathyXConfig): Module<EmptySearchState, RootStoreState> {
  return {
    namespaced: true,
    modules: {
      recommendations: getRecommendationsModule(initialConfig, { namespaced: false, state: { origin: QueryOrigin.emptySearch } }),
      discoveryWall: getDiscoveryWallModule({ namespaced: false })
    },
    state: {},
    actions: {},
    mutations: {}
  };
}
